import { cookieLangName, getCookie } from '@root/src/cookie';
  const exchangeRates = {
    usd: 25398,
    cny: 3520,
  };

export const convertCurrency = (amount: number): string => {
  const currency = getCookie(cookieLangName) || 'vn';
    if (!amount || amount <= 0) {
    return  currency === 'zh' ? '0 CNY' :  currency === 'en' ? '0 USD' : '0 VND' ;
  }
  let convertedAmount = amount;
  if (currency === 'en') {
    convertedAmount = amount / exchangeRates.usd;
    return `$${convertedAmount.toFixed(2)} USD`;
  } else if (currency === 'zh') {
    convertedAmount = amount / exchangeRates.cny;
    return `¥${convertedAmount.toFixed(2)} CNY`;
  } else {
    return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' VND';
  }
};

export const convertCurrencyServer = (amount: number, currency): string => {
  if (!amount || amount <= 0) {
    return  currency === 'zh' ? '0 CNY' :  currency === 'en' ? '0 USD' : '0 VND' ;
  }
  let convertedAmount = amount;
  if (currency === 'en') {
    convertedAmount = amount / exchangeRates.usd;
    return `$${convertedAmount.toFixed(2)} USD`;
  } else if (currency === 'zh') {
    convertedAmount = amount / exchangeRates.cny;
    return `¥${convertedAmount.toFixed(2)} CNY`;
  } else {
    return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' VND';
  }
};

export const calculateDiscountedPrice = (price, discount) => {
  if (!price || price <= 0 || !discount || discount < 0) {
    return 0;
  }

  return price - (price * discount) / 100;
};